import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {
  PrivacyRole,
  PrivacyRoleCreateRequest,
  PrivacyRoleCreateResponse,
  PrivacyRoleUpdateRequest,
  PrivacyRoleUpdateResponse
} from '@ms-organization-entities';
import {ApiClientConfig} from '../api-client-config';
import {PriorityPatchRequest, PrivacyRolePatchRequest} from '@primatoo-ms-organization';
import {DataProtectionGovernanceService} from '../interface/data-protection-governance-service';
import {ColumnWithLocalization} from 'it/primatoo/openapi/api/org/schemas/common/ColumnWithLocalization';

@Injectable({
  providedIn: 'root'
})
export class PrivacyRoleService extends DataProtectionGovernanceService {
  private readonly endpoint: string;

  constructor(
    @Inject(ApiClientConfig) private config,
    public httpClient: HttpClient
  ) {
    super(httpClient);
    this.endpoint = this.config.endPoint + '/api/org/privacy-roles/';
  }

  public getPrivacyRoles(): Observable<PrivacyRole[]> {
    const url = this.endpoint;
    return this.httpClient.get<PrivacyRole[]>(url);
  }

  public setPriority(id: number, request: PriorityPatchRequest): Observable<PrivacyRole> {
    const url = `${this.endpoint}${id}/priority`;
    return this.httpClient.patch<PrivacyRole>(url, request);
  }

  public getPrivacyRoleById(id: number): Observable<PrivacyRole> {
    const url = this.endpoint + id + '/';
    return this.httpClient.get<PrivacyRole>(url);
  }

  public deletePrivacyRole(id: number): Observable<PrivacyRole> {
    const url = this.endpoint + id + '/';
    return this.httpClient.delete<PrivacyRole>(url);
  }

  public createPrivacyRole(requestBody: PrivacyRoleCreateRequest): Observable<PrivacyRoleCreateResponse> {
    const url = this.endpoint;
    return this.httpClient.post<PrivacyRoleCreateResponse>(url, requestBody);
  }

  public updatePrivacyRole(id: number, requestBody: PrivacyRoleUpdateRequest): Observable<PrivacyRoleUpdateResponse> {
    const url = this.endpoint + id + '/';
    return this.httpClient.put<PrivacyRoleUpdateResponse>(url, requestBody);
  }

  public renamePrivacyRole(id: number, requestBody: PrivacyRolePatchRequest): Observable<PrivacyRole> {
    const url = this.endpoint + id + '/rename/';
    return this.httpClient.patch<PrivacyRole>(url, requestBody);
  }

  public findUserColumns(): Observable<ColumnWithLocalization[]> {
    const url = this.endpoint + `columns`;
    return this.httpClient.get<ColumnWithLocalization[]>(url);
  }

  // public updateUserColumns(columnsConfigurationUpsertRequest: ColumnsConfigurationUpsertRequest): Observable<void> {
  //   const url = this.endpoint + 'user-columns';
  //   return this.httpClient.post<void>(url, columnsConfigurationUpsertRequest);
  // }

  getEndPointV1(): string {
    return this.endpoint;
  }

}
